// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Skillet$LiteracyplanetTupperware from "./Skillet.res.mjs";
import * as TupperwareLayoutSwitch$LiteracyplanetTupperware from "../v3/TupperwareLayoutSwitch.res.mjs";

function SkilfulContent$Skilful(props) {
  return React.createElement("div", {
              className: Skillet$LiteracyplanetTupperware.SkilfulContent.className
            }, props.children);
}

var Skilful = {
  make: SkilfulContent$Skilful
};

function SkilfulContent$PilotContent(props) {
  return React.createElement("div", {
              className: "select-none"
            }, props.children);
}

var PilotContent = {
  make: SkilfulContent$PilotContent
};

function SkilfulContent(props) {
  var children = props.children;
  if (Curry._1(TupperwareLayoutSwitch$LiteracyplanetTupperware.use, undefined) === "Pilot") {
    return React.createElement(SkilfulContent$PilotContent, {
                children: children
              });
  } else {
    return React.createElement(SkilfulContent$Skilful, {
                children: children
              });
  }
}

var make = SkilfulContent;

var $$default = SkilfulContent;

export {
  Skilful ,
  PilotContent ,
  make ,
  $$default as default,
}
/* react Not a pure module */
